var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOzon = function SvgOzon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    x: 2.5,
    y: 2.5,
    fill: "currentColor",
    fillOpacity: 0.12,
    rx: 6
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 16,
    fill: "currentColor",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 700,
    textAnchor: "middle"
  }, "O")));
};
export default SvgOzon;